import { IconDots as TablerIconDots } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconDots = /*#__PURE__*/ createOutlineIcon(TablerIconDots, 'IconDots');
